module.exports = __webpack_public_path__ + "assets/img/img-detail-bottom-sp.d5b3d5f1.jpg";